app-dialog {
	display: contents;

	& > :where(dialog:modal) {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size:  100%;
		inline-size: 100%;
		max-block-size:  unset;
		max-inline-size: unset;
		padding: 0;
		background: none;
		border: none;

		&:not(.closing) {
			&, &::backdrop {
				animation: open-dialog 0.15s ease-in-out;
			}

			@keyframes open-dialog {
				from {
					opacity: 0;
				}
				to {
					opacity: 1;
				}
			}
		}
		&.closing {
			&, &::backdrop {
				animation: close-dialog 0.15s ease-in-out;
			}

			@keyframes close-dialog {
				from {
					opacity: 1;
				}
				to {
					opacity: 0;
				}
			}
		}

		&::backdrop {
			background: none;
			backdrop-filter: contrast(55%) brightness(35%) blur(16px);
		}

		& > .dialog {
			display: flex;
			flex-direction: column;
			max-width:  80vw;
    		max-height: 80vh;
		}

		.dialog__fallback-header {
			display: flex;
			align-items: center;

			h2 {
				margin: 0;
			}

			form[method='dialog'] {
				margin-inline-start: auto;

				button {
					display: grid;
					place-content: center;
					aspect-ratio: 1;
					inline-size: 45px;
					block-size:  45px;

					app-icon[icon='close-thin'] svg {
						inline-size: 100%;
					}
				}
			}
		}

		.dialog__body {
			overflow: auto;
		}
	}

	&:where(.transparent) > :where(dialog:modal) {
		& > .dialog {
			color: white;

			* {
				color: inherit;
			}
		}

		.dialog__fallback-header {
			--transparent-to-backdrop: true;
		}
	}

	&:where(:not(.transparent)) > :where(dialog:modal) {
		& > .dialog {
			inline-size: 300px;
			background-color: white;
		}

		.dialog__fallback-header {
			h2 {
				padding: 16px;
				padding-block-end: 0;
			}
		}

		.dialog__body {
			padding: 16px;
		}
	}
}
